import { useCallback, useState } from 'react';

import { defineMessages, useIntl } from 'react-intl';

import classNames from 'classnames';

import ChevronLeftIcon from '@/material-icons/400-24px/chevron_left.svg?react';
import ChevronRightIcon from '@/material-icons/400-24px/chevron_right.svg?react';
import { Icon } from 'mastodon/components/icon';
import { NavigationPanel } from 'mastodon/features/navigation_panel';
import { getNavigationSkipLinkId } from 'mastodon/features/ui/components/skip_links';

const messages = defineMessages({
  expand: {
    id: 'navigation_panel.expand',
    defaultMessage: 'Expand navigation',
  },
  collapse: {
    id: 'navigation_panel.collapse',
    defaultMessage: 'Collapse navigation',
  },
});

const STORAGE_KEY = 'deck_nav_expanded';

const getStoredExpanded = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

// Persistent left-hand navigation for the advanced (deck) layout: a narrow
// icon-only rail that can be toggled open to reveal the labels.
export const NavigationPanelRail: React.FC = () => {
  const intl = useIntl();
  const [expanded, setExpanded] = useState(getStoredExpanded);

  const handleToggle = useCallback(() => {
    setExpanded((value) => {
      const next = !value;

      try {
        localStorage.setItem(STORAGE_KEY, next ? 'true' : 'false');
      } catch {
        // Ignore write failures (e.g. private browsing).
      }

      return next;
    });
  }, []);

  const label = intl.formatMessage(
    expanded ? messages.collapse : messages.expand,
  );

  return (
    <div
      id={getNavigationSkipLinkId()}
      tabIndex={-1}
      className={classNames('navigation-panel__rail', {
        'navigation-panel__rail--expanded': expanded,
      })}
    >
      <button
        type='button'
        className='navigation-panel__rail__toggle'
        onClick={handleToggle}
        aria-expanded={expanded}
        aria-label={label}
        title={label}
      >
        <Icon id='' icon={expanded ? ChevronLeftIcon : ChevronRightIcon} />
      </button>

      <NavigationPanel multiColumn />
    </div>
  );
};
